import { DashboardIdeaStartedAndFinishedDto } from '../dto/DashboardIdeaStartedAndFinishedDto';
import Envoy from '../util/Envoy';
import { IdeaWithoutTreatmentDTO } from '../dto/IdeaWithoutTreatmentDto';
import { DashboardIdeaWithoutEvaluation } from '../dto/DashboardIdeaWithoutEvaluation';
import { IdeaFinishedDTO } from '../dto/IdeaFinishedDTO';
import { IdeaWithEvaluationAndWithoutTreatmentDTO } from '../dto/DashboardLastTenHighScoreDto';
import { MonthlyEvaluationDTO } from '../dto/MonthlyEvaluationDto';

class DashboardProvider extends Envoy {
  public async getIdeasStartedAndFinished(year?: number): Promise<Array<DashboardIdeaStartedAndFinishedDto>> {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado.");
      }

      this.conn.defaults.headers.Authorization = `Bearer ${token}`;
      const response = await this.conn.get(`/chart/dashboard/ideas-started-and-finished`, {
        params: { year }
      });

      if (response.data.messages?.length)
        throw new Error(response.data.messages.join('\n'));
      return response.data.data;
    } catch (error) {
      console.error('Erro ao obter dados do dashboard:', error);
      throw error;
    }
  }

  public async getIdeasWithoutTreatment(): Promise<IdeaWithoutTreatmentDTO> {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado.");
      }

      this.conn.defaults.headers.Authorization = `Bearer ${token}`;
      const response = await this.conn.get(`/chart/dashboard/ideas-without-treatment`);

      if (response.data.messages?.length)
        throw new Error(response.data.messages.join('\n'));
      return response.data.data;
    } catch (error) {
      console.error('Erro ao obter dados do dashboard:', error);
      throw error;
    }
  }

  public async getIdeasWithoutEvaluation(): Promise<Array<DashboardIdeaWithoutEvaluation>> {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado.");
      }

      this.conn.defaults.headers.Authorization = `Bearer ${token}`;
      const response = await this.conn.get(`/chart/dashboard/ideas-without-evaluation`);

      if (response.data.messages?.length)
        throw new Error(response.data.messages.join('\n'));
      return response.data.data;
    } catch (error) {
      console.error('Erro ao obter dados do dashboard:', error);
      throw error;
    }
  }

  public async getTopIdeasWithEvaluationAndWithoutTreatment(): Promise<Array<IdeaWithEvaluationAndWithoutTreatmentDTO>> {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado.");
      }

      this.conn.defaults.headers.Authorization = `Bearer ${token}`;
      const response = await this.conn.get(`/chart/dashboard/top-ideas-with-evaluation-and-without-treatment`);

      if (response.data.messages?.length)
        throw new Error(response.data.messages.join('\n'));
      return response.data.data;
    } catch (error) {
      console.error('Erro ao obter dados do dashboard:', error);
      throw error;
    }
  }

  public async getIdeasWithLowEvaluationAndWithoutTreatment(): Promise<Array<IdeaWithEvaluationAndWithoutTreatmentDTO>> {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado.");
      }

      this.conn.defaults.headers.Authorization = `Bearer ${token}`;
      const response = await this.conn.get(`/chart/dashboard/ideas-with-low-evaluation-and-without-treatment`);

      if (response.data.messages?.length)
        throw new Error(response.data.messages.join('\n'));
      return response.data.data;
    } catch (error) {
      console.error('Erro ao obter dados do dashboard:', error);
      throw error;
    }
  }

  public async getIdeasFinished(): Promise<Array<IdeaFinishedDTO>> {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado.");
      }

      this.conn.defaults.headers.Authorization = `Bearer ${token}`;
      const response = await this.conn.get(`/chart/dashboard/ideas-finished`);

      if (response.data.messages?.length)
        throw new Error(response.data.messages.join('\n'));
      return response.data.data;
    } catch (error) {
      console.error('Erro ao obter dados do dashboard:', error);
      throw error;
    }
  }

  public async getMonthlyEvaluationPercentage(year?: number): Promise<Array<MonthlyEvaluationDTO>> {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado.");
      }

      this.conn.defaults.headers.Authorization = `Bearer ${token}`;
      const response = await this.conn.get(`/chart/dashboard/monthly-evaluation-percentage`, {
        params: { year }
      });

      if (response.data.messages?.length)
        throw new Error(response.data.messages.join('\n'));
      return response.data.data;
    } catch (error) {
      console.error('Erro ao obter dados do dashboard:', error);
      throw error;
    }
  }

  public async getTEIPPMonthlyEvaluationPercentage(year?: number): Promise<Array<MonthlyEvaluationDTO>> {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado.");
      }

      this.conn.defaults.headers.Authorization = `Bearer ${token}`;
      const response = await this.conn.get(`/chart/dashboard/teipp-monthly-evaluation-percentage`, {
        params: { year }
      });

      if (response.data.messages?.length)
        throw new Error(response.data.messages.join('\n'));
      return response.data.data;
    } catch (error) {
      console.error('Erro ao obter dados do dashboard:', error);
      throw error;
    }
  }

  public async getTCIAPCMonthlyEvaluationPercentage(year?: number): Promise<Array<MonthlyEvaluationDTO>> {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado.");
      }

      this.conn.defaults.headers.Authorization = `Bearer ${token}`;
      const response = await this.conn.get(`/chart/dashboard/tciapc-monthly-evaluation-percentage`, {
        params: { year }
      });

      if (response.data.messages?.length)
        throw new Error(response.data.messages.join('\n'));
      return response.data.data;
    } catch (error) {
      console.error('Erro ao obter dados do dashboard:', error);
      throw error;
    }
  }

  public async getIdeasMovedFromIdeation(year?: number): Promise<Array<MonthlyEvaluationDTO>> {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado.");
      }

      this.conn.defaults.headers.Authorization = `Bearer ${token}`;
      const response = await this.conn.get(`/chart/dashboard/ideas-moved-from-ideation`, {
        params: { year }
      });

      if (response.data.messages?.length)
        throw new Error(response.data.messages.join('\n'));
      return response.data.data;
    } catch (error) {
      console.error('Erro ao obter dados do dashboard:', error);
      throw error;
    }
  }
}

export default DashboardProvider;
